import { useMemo } from "react";
import { getGroupColors } from "../../../shared/helpers";
import { EThemeGradients } from "../../../tokens";
import { useTheme } from "../../ThemeProvider";
import { getRadialGradient } from "../utils";
function useAvatarColors(parentBg, gradient) {
  const theme = useTheme();
  const palette = getGroupColors(theme, parentBg);
  const colorConfig = useMemo(() => {
    const isGradientActive = gradient && gradient !== EThemeGradients.NONE;
    const background = isGradientActive && theme.palette.gradients[gradient] ? getRadialGradient(theme.palette.gradients[gradient]) : palette.transparent;
    const contentColor = isGradientActive ? theme.palette.static.light : palette.lowContrast;
    return {
      background,
      contentColor
    };
  }, [parentBg, gradient, theme, palette]);
  return colorConfig;
}
export {
  useAvatarColors
};
